import { render, staticRenderFns } from "./EmployeeCosts.vue?vue&type=template&id=8cb8280c&scoped=true"
import script from "./EmployeeCosts.vue?vue&type=script&lang=js"
export * from "./EmployeeCosts.vue?vue&type=script&lang=js"
import style0 from "./EmployeeCosts.vue?vue&type=style&index=0&id=8cb8280c&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb8280c",
  null
  
)

export default component.exports